import { Box, Button, Menu, MenuItem, Typography, Link, Divider } from "@material-ui/core";
import { useState, MouseEvent } from "react";
import validator_icon from 'src/assets/images/validator_icon.svg';
import infrastructure_icon from 'src/assets/images/infrastructure_icon.svg'
import { borderColor } from "@material-ui/system";


interface HeaderMenuProps {
    text: string,
    menuItems: { link: string, text: string, icon: any }[],
    horizontal?: number | 'right' | 'center' | 'left'
}
export const HeaderMenu = (props: HeaderMenuProps) => {
    // const [open, setOpen] = useState<boolean>(false);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return <>
        <Box mr={7}>
            <Link
                id={`${props.text}-link`}
                aria-controls={open ? `${props.text}-menu` : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                component="button"
                variant="body2"
                style={{
                    textDecoration: "none",
                    height: "50px"
                }}
                onClick={handleClick}
            >
                <Typography
                    color="#0E1011"
                    sx={{
                        fontSize: "16px",
                    }}
                >
                    {props.text}
                </Typography>
            </Link>

        </Box>
        <Menu
            id={`${props.text}-menu`}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: props.horizontal || "left"
            }}
            PaperProps={{
                style: {
                    color: "#23292F",
                    fontSize: "14px",
                    border: "1px solid #C2C2C2"
                }
            }}
            MenuListProps={{
                'aria-labelledby': `${props.text}-link`,
                style: {
                    padding: "0px",

                }
            }}
        >

            {
                props.menuItems.map((item, index) => {
                    return <div key={`${props.text}div${index}`}>
                        <MenuItem onClick={() => {
                            window.open(item.link)
                        }} key={`${props.text}${index}`} style={{
                            height: "40px",
                            width: "160px",
                            paddingLeft: "20px",
                            fontSize: "14px"
                        }}>
                            <img src={item.icon} style={{
                                marginRight: "5px",
                            }} /> {item.text}
                        </MenuItem>
                        {index != (props.menuItems.length - 1) && <Divider key={`${props.text}divider${index}`} style={{
                            margin: "0px",
                            borderColor: "#C2C2C2"
                        }} />
                        }
                    </div>
                    // if (index == (props.menuItems.length - 1)) {
                    //     return <MenuItem key={`${props.text}${index}`} onClick={() => {
                    //         window.open(item.link)
                    //     }}  style={{
                    //         height: "40px"
                    //     }}>
                    //         <img src={item.icon} style={{
                    //             marginRight: "5px"
                    //         }} /> {item.text}
                    //     </MenuItem>
                    // } else {

                    // }

                })
            }


        </Menu>
    </>
}